<template>
<div class="input-group mb-3 col-md-5 pl-0">
    <!-- <slot></slot> -->
    <input class="form-control" placeholder="Search" @keyup="filterGrid" @keydown="prevendEnter" v-model="config.SearchData"/>
    <div class="input-group-append">
			<span class="input-group-text"><i class='fa fa-search'></i></span>
    </div>
</div>
</template>

<script>
export default {
	props: ["config"],
	methods: {
		filterGrid: function (e) {
				this.$emit("keyupSearch", e)
		},
		prevendEnter: function(e){
			if(e.keyCode ===13)
			e.preventDefault();
		}
	}
}
</script>

<style scoped>
input {
	background: #fff !important;
	border-bottom: black !important;
	border-bottom-width: thin !important;
	border-bottom-style: solid !important;
	border-radius: 0px !important;
	font-style: italic !important;
	font-size: 20px !important;
}
input:focus{
	background: #fff !important;
	border-bottom: black !important;
	border-bottom-width: thin !important;
	border-bottom-style: solid !important;
	border-radius: 0px !important;
}
.input-group-append .input-group-text {
	background: #fff !important;
	border-bottom: black !important;
	border-bottom-width: thin !important;
	border-bottom-style: solid !important;
	border-radius: 0px !important;
}

input.form-control:focus{
	background: #fff !important;
	border:none !important;
	border-bottom: black !important;
	border-bottom-width: thin !important;
	border-bottom-style: solid !important;
}
</style>
